<!-- version 2021/05/20 -->
<template>
  <a :href="link" class="d-flex justify-content-center flex-column px-3 py-3">
    <div class="d-flex align-items-center imgBox">
      <img :src="imagePath" alt="Flower Photo" class="" :style="styleObject" />
      <app-title-text :text="title" class="ml-3 gray"></app-title-text>
    </div>
    <app-normal-text2 :text="description" class="" :style="styleObject"></app-normal-text2>
  </a>
</template>

<script>
export default {
  props: {
    imagePath: String,
    title: String,
    description: String,
    link: String,
  },
  data() {
    return {
      styleObject: {
        //  textAlign: "center",
        //width: "100%"
        minHeight: '50px',
      },
    };
  },
};
</script>

<style lang="sass" scoped>
.gray
  color: #405e66!important
a
  border-radius: 6px
  background-color: white
  border: 1px solid #c6e1e1
.imgBox
  min-height: 75px
</style>
